import { render, staticRenderFns } from "./TheAggregatedViewCampaigns.vue?vue&type=template&id=1a9788dd&scoped=true"
import script from "./TheAggregatedViewCampaigns.vue?vue&type=script&lang=js"
export * from "./TheAggregatedViewCampaigns.vue?vue&type=script&lang=js"
import style0 from "./TheAggregatedViewCampaigns.vue?vue&type=style&index=0&id=1a9788dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9788dd",
  null
  
)

export default component.exports